// extracted by mini-css-extract-plugin
module.exports = {"container":"introduce-form_container__hUDt6","title":"introduce-form_title__yn7xB","logout":"introduce-form_logout__1vMFG"};